<div id="enroll-mfa" class="mx-auto flex flex-column align-content-center align-items-center gap-4">

  <h2 class="mb-2" i18n>Enroll a new Authenticator App</h2>

  @if (displayQR) {
    <p class="my-0 py-0" i18n>Scan the QR Code with your chosen authenticator app and enter the code it has given you</p>
    <qrcode [qrdata]="otpURI" />
    <a tabindex="1" class="cursor-pointer dark" (click)="displayQR = !displayQR" (keydown)="displayQR = !displayQR" i18n>Can't scan this QR code?</a>
  } @else {
    <p class="my-0 py-0" i18n>Paste this code into your authenticator app:</p>
    <div class="flex flex-row">
      <div class="gap-0">
        <input id="totp-code" disabled [value]="otpURI!!" class="px-3 py-3">
      </div>
      <button
        class="p-button"
        type="button"
        (click)="copyCode()"
        (keydown)="copyCode()"
      >
        <i class="pi {{ this.uriCopied ? 'pi-check' : 'pi-clipboard' }}"></i>
      </button>
    </div>
    <a tabindex="1" class="cursor-pointer dark" (click)="displayQR = !displayQR" (keydown)="displayQR = !displayQR" i18n>View and scan QR code</a>
  }

  <p-inputOtp
    aria-label="One Time Passcode Input from your new app"
    [(ngModel)]="form!.code"
    [length]="6"
    [integerOnly]="true"
    (keyup.enter)="submit()"
  />

  @if (form!.errors.code === 'INVALID_CODE') {
    <p-message styleClass="mb-3" severity="error" i18n>Please enter the code generated by your Authenticator App</p-message>
  } @else if (success) {
    <p-message styleClass="mb-3" severity="success" i18n>Code confirmed!</p-message>
  }
  <button class="p-button form-btn" type="button" (click)="submit()" (keydown)="submit()" i18n>Verify</button>
  <!--
      TODO:
        - Get TOTP URL (or maybe just secret, algorithm?) from SSO Service
        - Send submitted code to SSO Service for verification
        - Error message for incorrect code
        - Submit details of new app upon verification

        - indicate option is already setup
        - option to delete existing solution

        - when editing SMS, can only edit number but not delete it
        - cannot delete email
  -->

</div>
